import { BrowserEntryType } from '@lucidlink/uicore';
import { folder, folderVirtual, shortcut } from '#assets';
import { getFileImageFromName } from '#services';
export const getBrowserEntryImage = (entry) => {
    if (entry.type === BrowserEntryType.DIR) {
        return entry.data.isVirtualDir ? folderVirtual : folder;
    }
    if (entry.type === BrowserEntryType.LINK) {
        return shortcut;
    }
    return getFileImageFromName(entry.name);
};
